import React from 'react';
const SurgeonIcon = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 12C14.8406 12 17.1429 9.76172 17.1429 7C17.1429 4.23828 14.8406 2 12 2C9.15938 2 6.85714 4.23828 6.85714 7C6.85714 9.76172 9.15938 12 12 12ZM15.6 13.25H14.929C14.0371 13.6484 13.0446 13.875 12 13.875C10.9554 13.875 9.96696 13.6484 9.07098 13.25H8.4C5.41875 13.25 3 15.6016 3 18.5V20.125C3 21.1602 3.86384 22 4.92857 22H19.0714C20.1362 22 21 21.1602 21 20.125V18.5C21 15.6016 18.5813 13.25 15.6 13.25Z"
				fill="url(#paint0_linear_7404_3105)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_7404_3105"
					x1="25.2065"
					y1="12"
					x2="-1.40217"
					y2="12"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#01B1D5" />
					<stop offset="1" stopColor="#06038D" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default SurgeonIcon;
